import angular from 'angular';
import rwRequiredOneOfDirecttive from './rw-required-one-of-directive';

export default angular.module('rwRequiredOneOf', [])
  .directive('rwRequiredOneOf', rwRequiredOneOfDirecttive);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-required-one-of/rw-required-one-of-module.js